<template>
  <div style="margin: 0 auto;">
    <a-card :bordered="false" class="panel-header">
      <div class="select">
        <a
          href="javascript:void(0)"
          @click="langTypeChange(undefined)"
          :class="queryParam.langType? '': 'selected'"
          >全部</a
        >
        <!-- <a
          href="javascript:void(0)"
          @click="langTypeChange('file')"
          :class="queryParam.langType=='file' ? 'selected' : ''"
          >积木构建项目</a
        > -->
        <a
          href="javascript:void(0)"
          @click="langTypeChange('scratchjr')"
          :class="queryParam.langType=='scratchjr' ? 'selected' : ''"
          >Scratch jr</a
        >
        <a
          href="javascript:void(0)"
          @click="langTypeChange('scratch')"
          :class="queryParam.langType=='scratch' ? 'selected' : ''"
          >Scratch</a
        >
        <a
          href="javascript:void(0)"
          @click="langTypeChange('blockly')"
          :class="queryParam.langType=='blockly' ? 'selected' : ''"
          >Blockly</a
        >
        <a href="javascript:void(0)"
          @click="langTypeChange('python')"
          :class="queryParam.langType=='python' ? 'selected' : ''"
          >Python</a>

          <a href="javascript:void(0)"
          @click="langTypeChange('clang')"
          :class="queryParam.langType=='clang' ? 'selected' : ''"
          >C++</a>
          <a-divider type="vertical"></a-divider>
          <a v-if="myDepIds"
              style="border-radius:5px;"
              href="javascript:void(0)"
              @click="onSelectMyDept()"
              :class="queryParam.depId? 'selected' : ''"
              >只看我的班级</a
            >
      </div>
      <a-row type="flex" :gutter="[24, 24]">
        <a-col v-show="queryParam.langType==undefined||queryParam.langType=='scratch'" :xs="24" :sm="24" :md="24" :lg="15" :xl="16" class="catalog">
          <div
            :class="['tag-wrap', queryParam.workTag == '' ? 'selected' : '']"
            @click="tagChange('');"
          >
            所有
          </div>
          <div
            :class="['tag-wrap', queryParam.workTag == tag ? 'selected' : '']"
            v-for="(tag, index) in tags"
            :key="index"
            @click="tagChange(tag);"
          >
            {{ tag }}
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="9" :xl="8">
          <a-input-search
            placeholder="搜索"
            style="width: 200px"
            @search="onSearch"
          />
          <a-divider type="vertical"></a-divider>
          <a-radio-group
            v-model="queryParam.orderBy"
            @change="pageChange(1, 12)"
          >
            <a-radio-button value="view"> 最热 </a-radio-button>
            <a-radio-button value="time"> 最新 </a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
    </a-card>
    <a-card :bordered="false">
      <a-row type="flex" :gutter="[24, 24]">
        <a-col
          v-for="(item, index) in workList"
          :key="index"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          :xl="6"
        >
          <a-card class="work-card">
            <div class="work-cover">
              <a @click="toDetail(item)" target="_blank" class="img-zoom">
                <img v-if="item.workCover" :src="item.workCover_url" />
                <img v-else :src="getCodeIcon(item.codeType)" />
              </a>
            </div>
            <a-row class="work-author">
              <a-col :span="6">
                <a-avatar
                  shape="square"
                  class="avatar"
                  :size="40"
                  :src="item.avatar?item.avatar_url:'/img/avatar.png'"
                  @click="toUserInfo(item)"
                  style="cursor: pointer"
                />
              </a-col>
              <a-col :span="18">
                <span @click="toUserInfo(item)" style="cursor: pointer">{{
                  item.realname || item.username
                }}</span>
              </a-col>
            </a-row>
            <a-divider></a-divider>
            <div class="work-op">
              <a @click="toDetail(item)">{{ item.workName }}</a>
              <a-row type="flex" justify="end">
                <a-col :span="6">
                  <a-icon type="eye" /> {{ item.viewNum }}
                </a-col>
                <a-col :span="6">
                  <a-icon type="like" /> {{ item.starNum }}
                </a-col>
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </a-card>
    <a-pagination
      @change="pageChange"
      :current="ipagination.current"
      :pageSize="ipagination.pageSize"
      :pageSizeOptions="ipagination.pageSizeOptions"
      :showTotal="ipagination.showTotal"
      :total="ipagination.total"
      showQuickJumper
    />
  </div>
</template>

<script>
import Vue from "vue";
import "@/assets/less/animation.css";
import { mixinDevice } from "@/utils/mixin.js";
import { getAction } from "@/api/manage";
import {
  getEditorUrl,
  getPlayerUrl,
  getCodeIcon,
} from "@/utils/codeTypeUtil.js";

export default {
  components: {},
  data() {
    return {
      workList: [],
      ipagination: {
        current: 1,
        pageSize: 16,
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条";
        },
        showQuickJumper: true,
        total: 0,
      },
      myDepIds: '',
      queryParam: {
        langType: undefined,
        tag: "",
        orderBy: "time",
      },
      tags: ["游戏", "动画", "音乐", "模拟", "搞笑", "故事", "赛事"],
    };
  },
  created() {
    if(this.$store.getters.userInfo){
      this.getMyClassroom()
    }
    this.pageChange(1, 12);
  },
  mounted() {},
  methods: {
    getEditorUrl,
    getPlayerUrl,
    getCodeIcon,
    tagChange(tag){
      this.queryParam.workTag=tag
      this.pageChange(1, 12);
    },
    langTypeChange(type){
      this.queryParam.workTag = ''
      this.queryParam.langType = type
      this.pageChange(1, 12);
    },
    onSelectMyDept(){
      if(this.queryParam.depId){
        this.queryParam.depId = ''
      }else{
        this.queryParam.depId = this.myDepIds
      }
      this.pageChange(1, 12);
    },
    pageChange(page, pageSize) {
      this.dataSource = [];
      this.ipagination.current = page;
      this.ipagination.pageSize = pageSize;
      this.queryParam.pageNo = this.ipagination.current;
      this.queryParam.pageSize = this.ipagination.pageSize
      this.getWorkList();
    },
    onSearch(v) {
      this.queryParam.workTag = ''
      this.queryParam.langType = undefined
      this.queryParam.workName = v;
      this.pageChange(1, 12);
    },
    getMyClassroom(){
      getAction("/sys/sysDepart/mineClassroom").then(res=>{
        if(res.result){
          this.myDepIds = res.result.map((item,index)=>{return item.id}).join(',')
        }
      })
    },
    getWorkList() {
      console.log(this.queryParam);
      this.workList = []
      getAction("/teaching/teachingWork/leaderboard", this.queryParam).then(
        (res) => {
          if (res.success) {
            this.ipagination.total = res.result.total;
            this.workList = res.result.records;
          }
        }
      );
    },
    toDetail(info) {
      if (info.codeType == 0) {
        this.$router.push("/work/mdView?workId=" + info.id);
      } else {
        this.$router.push("/work/detail?workId=" + info.id);
      }
    },
    toUserInfo(info) {
      this.$router.push("/friend/detail?id=" + info.userId);
    },
  },
};
</script>

<style lang="less" scoped>
.panel-header {
  //   background: #24a6e9;
  min-height: 80px;
  .select {
    font-size: 13px;
    margin: 40px 0 10px 0px;
    a {
      color: black !important;
      font: normal normal normal 27px/17px HappyZcool-2016;
      font-weight: 500;
      font-size: 17px;
      line-height: 45px;
      display: inline-block;
      border-radius: 40px;
      padding: 0 35px;
      box-shadow: 0px 3px 6px #00000029;
      min-width: 110px;
      height: 46px;
      margin-right: 20px;
      margin-bottom: 20px;
      &.selected {
        color: #fff !important;
        background-color: rgba(57, 165, 239, 1);
      }
    }

    &:hover {
      color: #333;
    }
  }
  .catalog {
    color: #027db4;
    .tag-wrap {
      cursor: pointer;
      display: inline;
      border-radius: 50px;
      background: #f2f2f2;
      margin: 0 10px;
      padding: 5px 10px;
      font-size: 14px;
      line-height: 40px;
    }
    span {
      vertical-align: middle;
      margin-right: 50px;
    }
    .selected {
      background: #027db4;
      color: white;
    }
  }
}
.work-card {
  border: none;

  /deep/.ant-card-body {
    width: 250px;
    height: 280px;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0px 3px 6px #00000039;
  }
  .ant-divider-horizontal {
    margin: 12px 0;
  }
  .work-cover {
    width: 100%;
    max-height: 150px;
    overflow: hidden;
    img {
      display: block;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
  .work-author {
    padding: 10px 10px 0;
    span {
      line-height: 40px;
    }
  }
  .work-op {
    a {
      color: black;
    }
    a:hover {
      color: #1890ff;
    }
    padding: 0 10px;
  }
}
.ant-pagination {
  text-align: center;
  margin-top: 20px;
}
</style>